/* =========================================================
   K.NOAH — QUOTE DATA COLLECTOR V3
   READ ONLY
   ========================================================= */

(function () {
  'use strict';

  window.KNOAH_QUOTE_DATA_V3 = true;


  /* =====================================================
     HELPERS
     ===================================================== */

  function clean(v) {
    return String(v == null ? '' : v)
      .replace(/\s+/g, ' ')
      .trim();
  }

  function id(x) {
    return document.getElementById(x);
  }

  function title(v) {
    v = clean(v);

    if (!v) return '';

    if (v.toLowerCase() === 'none') return 'None';
    if (v.toLowerCase() === 'true') return 'Yes';
    if (v.toLowerCase() === 'false') return 'No';

    return v
      .replace(/[-_]+/g, ' ')
      .replace(/\b\w/g, function (m) {
        return m.toUpperCase();
      });
  }

  function active(selector, root) {
    root = root || document;

    var nodes = root.querySelectorAll(selector);

    for (var i = 0; i < nodes.length; i++) {

      var n = nodes[i];

      if (
        n.classList.contains('active') ||
        n.classList.contains('selected') ||
        n.classList.contains('is-active') ||
        n.getAttribute('aria-pressed') === 'true' ||
        n.getAttribute('aria-selected') === 'true' ||
        (
          (n.type === 'radio' || n.type === 'checkbox') &&
          n.checked
        )
      ) {
        return n;
      }
    }

    return null;
  }

  function attrActive(selector, attrs, root) {

    var n = active(selector, root);

    if (!n) return '';

    attrs = attrs || [];

    for (var i = 0; i < attrs.length; i++) {

      var value = n.getAttribute(attrs[i]);

      if (value !== null && clean(value)) {
        return clean(value);
      }
    }

    return clean(n.textContent);
  }

  function inputValue(selector, root) {

    root = root || document;

    var n = root.querySelector(selector);

    return n ? clean(n.value) : '';
  }


  /* =====================================================
     EXACT K.NOAH COLOR PALETTE
     ===================================================== */

  var COLORS = {

    '#111111': 'BLACK',
    '#FFFFFF': 'WHITE',
    '#A6ABB0': 'GREY / SILVER',
    '#383B40': 'ANTHRACITE',
    '#653819': 'BROWN',

    '#CE2029': 'SCARLET RED',
    '#9D2235': 'CARDINAL RED',
    '#76283D': 'BURGUNDY',
    '#6A2036': 'MAROON',
    '#592C82': 'PURPLE',
    '#ED2788': 'HOT PINK',

    '#1746B5': 'ROYAL BLUE',
    '#17264C': 'NAVY BLUE',
    '#7BAFD4': 'CAROLINA BLUE',
    '#8CCCEB': 'SKY BLUE',
    '#111C35': 'MIDNIGHT BLUE',
    '#008C95': 'TEAL',
    '#00A6B2': 'AQUA',

    '#F5D928': 'YELLOW / LIGHT GOLD',
    '#F47721': 'ORANGE',
    '#C5B48B': 'VEGAS GOLD',
    '#FFB81C': 'ATHLETIC GOLD',
    '#FF8200': 'TENNESSEE ORANGE',
    '#BF5700': 'BURNT ORANGE',

    '#16834A': 'KELLY GREEN',
    '#154734': 'DARK GREEN',
    '#A4D65E': 'LIME GREEN'
  };


  function normalizeHex(v) {

    v = clean(v).toUpperCase();

    if (!v) return '';

    if (v.charAt(0) !== '#') {
      v = '#' + v;
    }

    return /^#[0-9A-F]{6}$/.test(v)
      ? v
      : '';
  }


  function colorLabel(hex) {

    hex = normalizeHex(hex);

    if (!hex) return '';

    if (COLORS[hex]) {
      return COLORS[hex] + ' (' + hex + ')';
    }

    return 'CUSTOM (' + hex + ')';
  }


  /* =====================================================
     GENERIC COLOR READER
     ===================================================== */

  function colorFromContainer(container) {

    if (!container) return '';

    var hex =
      container.querySelector(
        '.frx-hex-input'
      ) ||
      container.querySelector(
        'input[aria-label*="HEX"]'
      ) ||
      container.querySelector(
        'input[type="text"][maxlength="7"]'
      );

    if (
      hex &&
      normalizeHex(hex.value)
    ) {
      return colorLabel(hex.value);
    }


    var picker =
      container.querySelector(
        'input[type="color"]'
      );

    if (picker) {
      return colorLabel(picker.value);
    }


    var selected =
      active(
        '[data-color],' +
        '[data-hex]',
        container
      );

    if (selected) {

      var value =
        selected.dataset.color ||
        selected.dataset.hex;

      if (normalizeHex(value)) {
        return colorLabel(value);
      }
    }


    return '';
  }


  function targetColor(target) {

    var picker =
      document.querySelector(
        '.frx-color-picker[data-target="' +
        target +
        '"]'
      );

    if (!picker) return '';

    var wrap =
      picker.closest('.frx-color-control') ||
      picker.parentElement;

    return colorFromContainer(wrap);
  }


  /* =====================================================
     JERSEY COLORS
     ===================================================== */

  function jerseyColors() {

    return compact({

      'Body':
        targetColor('frx-body'),

      'Sleeve Panels':
        targetColor('frx-sleeves'),

      'Armpit Panels':
        targetColor('frx-armpit'),

      'Collar':
        targetColor('frx-collar'),

      'Sleeve Ends':
        targetColor('frx-sleeveends'),

      'Sleeve Binding':
        targetColor('frx-sleevebinding'),

      'Shoulder Laserholes':
        targetColor('frx-shoulderholes'),

      'Body Laserholes':
        targetColor('frx-bodyholes')

    });
  }


  /* =====================================================
     PATTERN
     ===================================================== */

  function jerseyPattern() {

    var pattern =
      attrActive(
        '#kn-pattern-controls [data-pattern]',
        ['data-pattern']
      ) || 'none';


    var result = {
      'Pattern': title(pattern)
    };


    if (pattern !== 'none') {

      var placement =
        attrActive(
          '#kn-pattern-placement-wrap [data-pattern-placement]',
          ['data-pattern-placement']
        ) ||
        attrActive(
          '#kn-pattern-placement-wrap [data-placement]',
          ['data-placement']
        );

      if (placement) {
        result['Pattern Placement'] =
          title(placement);
      }


      var colorWrap =
        id('kn-pattern-color-row') ||
        id('kn-pattern-color-wrap');

      var patternColor =
        colorFromContainer(colorWrap);

      if (patternColor) {
        result['Pattern Color'] =
          patternColor;
      }
    }


    return result;
  }


  /* =====================================================
     SLEEVE STRIPES
     ===================================================== */

  function sleeveStripes() {

    var result = {};


    /*
      CURRENT CONFIGURATOR
      Legacy/current DOM
    */

    var placement =
      attrActive(
        '#kn-stripe-placement [data-placement]',
        ['data-placement']
      ) ||
      attrActive(
        '[data-stripe-placement]',
        ['data-stripe-placement']
      );

    if (placement) {
      result['Sleeve Stripe Placement'] =
        title(placement);
    }


    var styleButton =
      active(
        '#kn-stripe-styles [data-style]'
      ) ||
      active(
        '[data-stripe-style]'
      ) ||
      active(
        '[data-kn23-style]'
      );


    var style = '';

    if (styleButton) {

      style =
        styleButton.dataset.style ||
        styleButton.dataset.stripeStyle ||
        styleButton.dataset.kn23Style ||
        clean(styleButton.textContent);

    }


    if (!style || style === 'none') {

      result['Sleeve Stripes'] =
        'None';

      return result;
    }


    result['Sleeve Stripe Style'] =
      /^style\s/i.test(style)
        ? title(style)
        : 'Style ' + title(style);


    /*
      Dynamic stripe rows.
      Works with current generated controls.
    */

    var rows =
      document.querySelectorAll(
        '#kn-stripe-config .kn-stripe-group,' +
        '#kn23-rows .kn23-row'
      );


    rows.forEach(function (row, index) {

      var number = index + 1;


      var finishButton =
        active(
          '[data-finish],' +
          '[data-stripe-finish],' +
          '.kn23-finishes button',
          row
        );


      var finish = '';

      if (finishButton) {

        finish =
          finishButton.dataset.finish ||
          finishButton.dataset.stripeFinish ||
          clean(finishButton.textContent);
      }


      if (finish) {

        result[
          'Stripe ' + number + ' Finish'
        ] = title(finish);
      }


      /*
        Mirror finishes intentionally have
        no standard stripe color.
      */

      var lower =
        finish.toLowerCase();

      if (
        lower.indexOf('silver') !== -1 ||
        lower.indexOf('gold') !== -1
      ) {
        return;
      }


      var color =
        colorFromContainer(row);

      if (color) {

        result[
          'Stripe ' + number + ' Color'
        ] = color;
      }

    });


    return result;
  }


  /* =====================================================
     NUMBERS
     ===================================================== */

  function mainNumberColor(type) {

    var nodes =
      Array.from(
        document.querySelectorAll(
          '[data-main-number-color="' +
          type +
          '"]'
        )
      );


    /*
      First try active palette button.
    */

    var selected =
      nodes.find(function (node) {

        return (
          node.classList.contains('active') ||
          node.getAttribute(
            'aria-pressed'
          ) === 'true'
        ) &&
        normalizeHex(
          node.dataset.color
        );

      });


    if (selected) {
      return colorLabel(
        selected.dataset.color
      );
    }


    /*
      Then actual color input.
    */

    var picker =
      nodes.find(function (node) {
        return (
          node.tagName === 'INPUT' &&
          node.type === 'color'
        );
      });


    if (picker) {
      return colorLabel(
        picker.value
      );
    }


    /*
      Finally inspect containing row.
    */

    if (nodes.length) {

      var row =
        nodes[0].closest(
          '.frx-option'
        );

      var c =
        colorFromContainer(row);

      if (c) return c;
    }


    return '';
  }


  function numberFinish() {

    var finish =
      id('kn-number-finish');

    if (!finish) return '';


    /*
      Mirror takes priority.
    */

    var mirror =
      active(
        '[data-mirror]',
        finish
      );

    if (mirror) {

      if (
        mirror.dataset.mirror === 'silver'
      ) {
        return 'Silver Mirror';
      }

      if (
        mirror.dataset.mirror === 'gold'
      ) {
        return 'Gold Mirror';
      }

      return title(
        mirror.dataset.mirror
      );
    }


    /*
      Standard MATTE / GLOSSY
    */

    var normal =
      active(
        '[data-nf]',
        finish
      );

    if (normal) {

      return title(
        normal.dataset.nf ||
        clean(normal.textContent)
      );
    }


    return '';
  }


  function numbers() {

    var style =
      attrActive(
        '[data-number-style]',
        ['data-number-style']
      );


    var placement =
      attrActive(
        '[data-number-placement]',
        ['data-number-placement']
      ) || 'none';


    var pattern =
      attrActive(
        '#kn-number-pattern [data-kn-number-pattern]',
        ['data-kn-number-pattern']
      ) || 'none';


    var result = {

      'Number Style':
        title(style),

      'Primary Color':
        mainNumberColor('primary'),

      'Outline Color':
        mainNumberColor('outline'),

      'Number Pattern':
        title(pattern),

      'Number Finish':
        numberFinish(),

      /*
        IMPORTANT:
        This is ADDITIONAL number placement,
        not main number placement.
      */

      'Additional Numbers':
        placement === 'none'
          ? 'None'
          : title(placement)

    };


    /*
      Number pattern color only matters
      when a pattern is active.
    */

    if (pattern !== 'none') {

      var patternColor =
        colorFromContainer(
          id('kn-number-pattern-color')
        );

      if (patternColor) {

        result[
          'Number Pattern Color'
        ] = patternColor;
      }
    }


    /*
      Additional number colors
    */

    if (placement !== 'none') {

      var extra =
        id('frx-additional-colors');

      if (extra) {

        var primary =
          extra.querySelector(
            '[data-additional-number-color="primary"],' +
            '[data-additional-primary-color]'
          );

        var outline =
          extra.querySelector(
            '[data-additional-number-color="outline"],' +
            '[data-additional-outline-color]'
          );


        var pRow =
          primary &&
          primary.closest('.frx-option');

        var oRow =
          outline &&
          outline.closest('.frx-option');


        var pColor =
          colorFromContainer(
            pRow || extra
          );

        var oColor =
          colorFromContainer(
            oRow || extra
          );


        if (pColor) {
          result[
            'Additional Primary Color'
          ] = pColor;
        }

        if (oColor) {
          result[
            'Additional Outline Color'
          ] = oColor;
        }
      }
    }


    return compact(result);
  }


  /* =====================================================
     NAMES
     ===================================================== */

  function names() {

    var teamType =
      attrActive(
        '[data-teamname-type]',
        ['data-teamname-type']
      ) || 'none';


    var playerEnabled =
      attrActive(
        '[data-playername-enabled]',
        ['data-playername-enabled']
      ) || 'false';


    var result = {

      'Team Name Type':
        title(teamType)

    };


    if (teamType === 'text') {

      result['Team Name'] =
        inputValue(
          '#frx-teamname-input'
        );

      result['Team Name Font'] =
        inputValue(
          '#frx-teamname-font'
        );

      result['Team Name Placement'] =
        title(
          attrActive(
            '[data-teamname-placement]',
            ['data-teamname-placement']
          )
        );

      result['Team Name Style'] =
        title(
          attrActive(
            '[data-teamname-style]',
            ['data-teamname-style']
          )
        );

      var teamOne =
        colorFromContainer(
          id('frx-teamname-one-color')
        );

      var teamTwo =
        colorFromContainer(
          id('frx-teamname-two-color')
        );

      if (teamOne) {
        result['Team Name Color'] =
          teamOne;
      }

      if (teamTwo) {
        result[
          'Team Name Secondary Color'
        ] = teamTwo;
      }

    }


    if (teamType === 'upload') {

      var file =
        id('frx-teamname-file');

      if (
        file &&
        file.files &&
        file.files.length
      ) {
        result['Uploaded Wordmark'] =
          file.files[0].name;
      }

      result['Wordmark Placement'] =
        title(
          attrActive(
            '[data-upload-placement]',
            ['data-upload-placement']
          )
        );
    }


    result['Player Name Enabled'] =
      title(playerEnabled);


    if (playerEnabled === 'true') {

      result['Player Name'] =
        inputValue(
          '#frx-playername-input'
        );

      result['Player Name Font'] =
        inputValue(
          '#frx-playername-font'
        );

      result['Player Name Style'] =
        title(
          attrActive(
            '[data-playername-style]',
            ['data-playername-style']
          )
        );


      var playerOne =
        colorFromContainer(
          id('frx-playername-one-color')
        );

      var playerTwo =
        colorFromContainer(
          id('frx-playername-two-color')
        );


      if (playerOne) {
        result['Player Name Color'] =
          playerOne;
      }

      if (playerTwo) {
        result[
          'Player Name Secondary Color'
        ] = playerTwo;
      }

    }


    return compact(result);
  }


  /* =====================================================
     LOGOS
     ===================================================== */

  function logos() {

    var result = {};


    var branding =
      active(
        '[data-branding-placement],' +
        '[data-branding]'
      );

    if (branding) {

      result['K.Noah Branding'] =
        title(
          branding.dataset.brandingPlacement ||
          branding.dataset.branding ||
          clean(branding.textContent)
        );
    }


    document
      .querySelectorAll(
        'input[type="file"]'
      )
      .forEach(function (input) {

        if (
          !input.files ||
          !input.files.length ||
          input.id ===
            'frx-teamname-file'
        ) {
          return;
        }


        var name =
          input.getAttribute(
            'aria-label'
          ) ||
          input.dataset.label ||
          input.name ||
          input.id ||
          'Uploaded Logo';


        result[title(name)] =
          Array.from(input.files)
            .map(function (file) {
              return file.name;
            })
            .join(', ');

      });


    var placements =
      document.querySelectorAll(
        '[data-logo-placement].active,' +
        '[data-upload-logo-placement].active'
      );


    placements.forEach(
      function (button, index) {

        result[
          'Logo Placement ' +
          (index + 1)
        ] =
          title(
            button.dataset.logoPlacement ||
            button.dataset.uploadLogoPlacement
          );

      }
    );


    return compact(result);
  }


  /* =====================================================
     PANTS
     ===================================================== */

  function pants() {

    var root =
      id('kn-pants-built');

    if (!root) return {};


    var result = {};


    /*
      ACTIVE SETTINGS
    */

    var stripe =
      active(
        '[data-pants-stripe]',
        root
      );

    if (stripe) {

      var stripeValue =
        stripe.dataset.pantsStripe;

      result['Side Panel Stripes'] =
        stripeValue === 'none'
          ? 'None'
          : title(stripeValue);
    }


    var pattern =
      active(
        '[data-p]',
        root
      );

    var patternValue =
      pattern
        ? pattern.dataset.p
        : 'none';


    result['Pants Pattern'] =
      title(patternValue);


    /*
      COLORS / INPUTS
    */

    root
      .querySelectorAll(
        '.kn-p-color-row'
      )
      .forEach(function (row) {

        var labelNode =
          row.closest(
            '.kn-p-color-block,' +
            '.kn-p-design-section'
          );

        var label = '';

        if (labelNode) {

          var heading =
            labelNode.querySelector(
              'strong,label,.kn-p-title'
            );

          if (heading) {
            label =
              clean(
                heading.textContent
              );
          }
        }


        if (!label) return;


        /*
          Don't report pattern color
          when no pattern exists.
        */

        if (
          patternValue === 'none' &&
          /pattern/i.test(label)
        ) {
          return;
        }


        var c =
          colorFromContainer(row);

        if (c) {
          result[
            title(label)
          ] = c;
        }

      });


    /*
      PANTS FINISHES
    */

    var finishes =
      root.querySelectorAll(
        '.kn-p-stripe-group'
      );


    finishes.forEach(
      function (group, index) {

        var f =
          active(
            '.kn-p-stripe-finish button,' +
            '[data-finish]',
            group
          );

        if (!f) return;


        var val =
          f.dataset.finish ||
          clean(f.textContent);


        result[
          'Pants Stripe ' +
          (index + 1) +
          ' Finish'
        ] = title(val);

      }
    );


    /*
      Logo size
    */

    var logoSize =
      id('kn-pant-logo-size');

    if (logoSize) {

      result['Pants Logo Size'] =
        clean(logoSize.value) + '%';
    }


    return compact(result);
  }


  /* =====================================================
     CLEAN OBJECT
     ===================================================== */

  function compact(obj) {

    var out = {};

    Object.keys(obj || {})
      .forEach(function (key) {

        var value = obj[key];

        if (
          value === '' ||
          value === null ||
          value === undefined
        ) {
          return;
        }

        out[key] = value;
      });

    return out;
  }


  /* =====================================================
     COLLECT
     ===================================================== */

  function collect() {

    return {

      model: 'FRX',

      jersey: {

        colors:
          jerseyColors(),

        design:
          Object.assign(
            {},
            jerseyPattern(),
            sleeveStripes()
          ),

        numbers:
          numbers(),

        names:
          names(),

        logos:
          logos()

      },

      pants:
        pants()

    };
  }


  /* =====================================================
     MAIL TEXT
     ===================================================== */

  function section(
    output,
    titleText,
    data
  ) {

    data = compact(data);

    if (
      !Object.keys(data).length
    ) {
      return;
    }


    output.push('');
    output.push(titleText);
    output.push(
      '----------------------------------------'
    );


    Object.keys(data)
      .forEach(function (key) {

        output.push(
          key + ': ' + data[key]
        );

      });
  }


  function toText(data) {

    data = data || collect();

    var out = [];


    out.push(
      'MODEL: ' +
      (data.model || 'FRX')
    );


    out.push('');
    out.push('');
    out.push(
      'JERSEY CONFIGURATION'
    );
    out.push(
      '========================================'
    );


    section(
      out,
      'COLORS',
      data.jersey.colors
    );


    section(
      out,
      'DESIGN',
      data.jersey.design
    );


    section(
      out,
      'NUMBERS',
      data.jersey.numbers
    );


    section(
      out,
      'NAMES',
      data.jersey.names
    );


    section(
      out,
      'LOGOS',
      data.jersey.logos
    );


    out.push('');
    out.push('');
    out.push(
      'PANTS CONFIGURATION'
    );
    out.push(
      '========================================'
    );


    section(
      out,
      'PANTS',
      data.pants
    );


    return out.join('\n');
  }


  /* =====================================================
     PUBLIC API
     ===================================================== */

  window.KNoahQuoteData = {

    collect: collect,

    toText: toText,

    colorLabel: colorLabel

  };


  console.log(
    'K.NOAH Quote Data Collector V3 loaded.'
  );

})();